module.exports = __webpack_public_path__ + "img/ziU237NNh4CxCmQ6LA2aTvZrLiTmTGSR5yFr31IH.4de8b327.png";